/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum LightlyDockerSelectionMethod {
    coreset = 'coreset',
    random = 'random'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const LightlyDockerSelectionMethodValidatorShape = [
    'coreset',
    'random'
];
export const LightlyDockerSelectionMethodValidator = yup.mixed().oneOf(LightlyDockerSelectionMethodValidatorShape);
export const LightlyDockerSelectionMethodStringifyShapeProperties = {};
export const LightlyDockerSelectionMethodStringifyShape: StringSchema = {
    title: 'LightlyDockerSelectionMethod Stringifier',
    type: 'string'
};
export const LightlyDockerSelectionMethodStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(LightlyDockerSelectionMethodStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function LightlyDockerSelectionMethodFromJSON(json: any): LightlyDockerSelectionMethod {
    return LightlyDockerSelectionMethodFromJSONTyped(json, false);
}
export function LightlyDockerSelectionMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): LightlyDockerSelectionMethod {
    return json as LightlyDockerSelectionMethod;
}
export function LightlyDockerSelectionMethodToJSON(value?: LightlyDockerSelectionMethod | null): any {
    return value as any;
}
